export const apiTablePageMessages = {
  en: {
    actionsColumns: {
      pathVerifications: {
        deleteConfirm: {
          header: (
            protocol: string,
            source: string,
            destination: string,
          ): string =>
            `${protocol} path from ${source} to ${destination} will be deleted`,
          subHeader: 'Do you really want to delete item?',
          btnConfirm: 'Delete',
          btnSecondaryConfirm: 'Cancel',
        },
      },
    },
    customPages: {
      pathVerifications: {
        btnAddPath: 'Add path',
      },
    },
  },
};
